import api from "./api";

export const authService = {
  /*
  // Register/Signup
  register: async (name, email, password) => {
    const response = await api.post('/auth/register', {
      name,
      email,
      password,
    });
    return response.data;
  },
  */

  // Manual login disabled — application now uses SSO only

  // Login
  login: async (email, password) => {
    const response = await api.post("/auth/login", {
      email,
      password
    });
    return response.data;
  },

  // Logout
  logout: async () => {
    try {
      await api.post("/auth/logout");
    } catch (error) {
      // console.error('Logout error:', error);
    } finally {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      localStorage.removeItem("ssoToken");
    }
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await api.get("/auth/me");
    return response.data;
  },

  // Refresh token
  refreshToken: async (refreshToken) => {
    const response = await api.post("/auth/refresh", {
      refreshToken
    });
    return response.data;
  },

  // Forgot password (if backend has this endpoint)
  forgotPassword: async (email) => {
    // This is a placeholder - implement when backend endpoint is available
    const response = await api.post("/auth/forgot-password", {
      email
    });
    return response.data;
  },

  // Change password (user changes their own password)
  changePassword: async (currentPassword, newPassword) => {
    const response = await api.put("/auth/change-password", {
      currentPassword,
      newPassword
    });
    return response.data;
  },

  // SSO token exchange
  ssoTokenExchange: async (code) => {
    // console.log('[SSO Frontend] Calling SSO token exchange endpoint: /auth/sso', { codePrefix: code ? code.substring(0, 10) + '...' : 'null' });
    try {
      const response = await api.post("/auth/sso", {
        code
      });
      // console.log('[SSO Frontend] SSO token exchange successful', {
      // success: response.data?.success,
      // hasData: !!response.data?.data,
      // hasUser: !!response.data?.data?.user,
      // hasTokens: !!response.data?.data?.ourTokens
      // });
      return response.data;
    } catch (error) {
      // Enhanced error logging for browser console
      const errorDetails = {
        timestamp: new Date().toISOString(),
        location: "authService.ssoTokenExchange",
        error: {
          message: error.message,
          name: error.name,
          code: error.code,
          stack: error.stack
        },
        response: {
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          headers: error.response?.headers
        },
        request: {
          url: error.config?.url,
          method: error.config?.method,
          baseURL: error.config?.baseURL,
          headers: error.config?.headers
        }
      };

      // console.error('[SSO Frontend] SSO token exchange failed - Full Error Details:', errorDetails);

      // Log exactly what we received from backend
      // console.log('[SSO Frontend] Backend error response received:', {
      // status: error.response?.status,
      // statusText: error.response?.statusText,
      // data: error.response?.data,
      // dataStringified: error.response?.data ? JSON.stringify(error.response?.data, null, 2) : 'null'
      // });

      // console.error('[SSO Frontend] Error Summary:', {
      // message: error.message,
      // status: error.response?.status,
      // errorCode: error.response?.data?.code || error.response?.data?.Code,
      // errorMessage: error.response?.data?.error || error.response?.data?.status || error.response?.data?.message,
      // fullResponse: error.response?.data
      // });

      throw error;
    }
  },

  // Refresh AccessRights for a given post (AccessRights are scoped per-post;
  // the login JWT only carries the rights for whichever post was active at
  // login time). Called when the user switches their active post.
  getAccessRights: async (postId) => {
    const ssoToken = localStorage.getItem("ssoToken");
    const response = await api.post("/auth/accessrights", {
      postId,
      ssoToken
    });
    return response.data;
  }
};
